import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Card, CardBody, CardTitle } from "components/ui/Card";
import { dispatchUserSlice } from "components/hooks/dispatchUserSlice";
import { fetchLoanHistorySummary } from "data/slices/users/loanHistorySummary";
import { fetchLoanHistoryInactive } from "data/slices/users/loanHistoryInactive";
import { useUser } from "components/hooks/useUser";
import { useCurrentUID } from "components/hooks/useCurrentUID";
import { Spinner } from "components/ui/Spinner";

import { Links } from "./Links";
import { Messaging } from "./Messaging";
import { XLSpacer } from "components/ui/VerticalSpacers";

export function LoanResourcesCardUI() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUID = useCurrentUID();

  dispatchUserSlice(fetchLoanHistorySummary);

  const loanHistorySummary = useUser((user) => user.loanHistorySummary);
  const loanHistoryInactive = useUser((user) => user.loanHistoryInactive);

  const { loadState: summaryLoadState, active: isActive } = loanHistorySummary;
  const {
    loadState: inactiveLoadState,
    messaging,
    links,
  } = loanHistoryInactive;

  useEffect(() => {
    if (isActive) {
      navigate("/finances/cumulative_loan_debt");
    } else {
      dispatch(fetchLoanHistoryInactive(currentUID));
    }
  }, [dispatch, navigate, isActive, currentUID]);

  const isReady = [summaryLoadState, inactiveLoadState].every(
    (i) => i === "success"
  );

  return (
    <Card data-testid="loan-resources-card">
      <CardTitle>
        <h2>Loan Resources</h2>
      </CardTitle>
      <CardBody>
        {isReady ? (
          <>
            <Messaging messaging={messaging} />
            <XLSpacer />
            <Links links={links} />
          </>
        ) : (
          <Spinner />
        )}
      </CardBody>
    </Card>
  );
}

LoanResourcesCardUI.displayName = "LoanResourcesCardUI";
